module.exports = __webpack_public_path__ + "static/media/emojis_05.67fe4b90.svg";